var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#75A4C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9358 25.3764C40.0675 22.3296 36.6057 20.6192 33.6933 20.7795C34.2978 20.0312 35.0121 19.3898 35.8913 18.8018C36.276 18.5345 36.1111 18 35.6166 18C33.2537 18 31.0008 18.9087 29.5721 20.4053C27.5939 19.1225 24.8464 18.588 22.1538 19.1225C21.7142 19.2294 21.6593 19.8708 22.0989 19.9777C23.2528 20.2984 24.4068 20.7795 25.3409 21.4209C22.3736 21.7416 19.2965 24.147 18.0326 27.5145C17.8678 27.9421 18.3623 28.2628 18.747 28.049C20.5603 26.8731 22.5934 25.9109 24.4068 25.6437C22.2637 27.2472 21.3845 30.2405 21.934 33.1269C22.0439 33.5546 22.6484 33.608 22.8132 33.1804C24.187 29.9733 26.385 28.2094 28.6929 28.1559C28.748 32.9666 28.4731 36.0134 26.8246 41.2517C26.7147 41.6258 26.9894 42 27.3741 42H32.5394C32.8141 42 33.0889 41.7862 33.1438 41.5189C33.1438 35.9065 32.7042 33.1804 31.4953 27.8352C33.9131 27.7283 36.276 29.118 37.9794 32.1114C38.1992 32.4855 38.8037 32.3786 38.8586 31.951C39.1883 28.8508 37.8146 25.9644 35.6166 24.6281C37.1552 24.6815 39.0784 25.1626 41.3863 26.0713C41.771 26.1782 42.1556 25.7506 41.9358 25.3764Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat2);
export default __webpack_public_path__ + "static/media/cat_2.7f55f6d606f938cc19a5dd8faf02686b.svg";
export { ForwardRef as ReactComponent };